// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1985":"9c25f1c8","2670":"ea6ca254"}[chunkId] + ".chunk.css";
};